import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { getProject } from "./api";
import { useFormContext } from "react-hook-form";
import { useMcsContext } from "../MCS.context";

const BOMDashboardContext = createContext();

export const useBOMDashboardContext = () => useContext(BOMDashboardContext);

function BOMDashboardContextProvider({ children, tabType }) {
  const {
    plant,
    isPlant,
    setSelectedDrawings: setPlantSelectedDrawings,
  } = useMcsContext();

  // console.log("plant in bom:", plant);

  const projectId = useParams();

  const [project, setProject] = React.useState({
    id: projectId.id,
    drawings: [],
  });
  const [currentTab, setCurrentTab] = React.useState(0);

  const setSelectedDrawings = (drawings) => {
    setProject({ ...project, selectedDrawings: drawings });
    setPlantSelectedDrawings(drawings);
  };

  if (!project.name && !isPlant) {
    const func = async () => {
      const res = await getProject({ projectId: project.id });
      setProject({ ...project, ...res, data: data() });
    };
    func();
  }

  const formContextData = useFormContext();
  const data = () => {
    if (formContextData?.getValues()?.revisions?.[0]) {
      const projData = formContextData?.getValues().revisions[0].data;
      return typeof projData === "string" ? JSON.parse(projData) : projData;
    }
  };

  const updateProjectAfterCreateMrq = (res) => {
    // console.log({ res });
    setProject({
      ...project,
      selectedDrawings: res.drawings,
      selectedMrq: res.mrq,
    });

    setCurrentTab(1);
  };

  const getProjectData = async () => {
    const res = await getProject({ projectId: project.id });
    setProject({ ...project, ...res, data: isPlant ? {} : data() });
  };

  React.useEffect(() => {
    !isPlant && getProjectData();
  }, []);

  return (
    <BOMDashboardContext.Provider
      value={{
        tabType,
        currentTab,
        setCurrentTab,
        project,
        plant,
        setProject,
        setSelectedDrawings,
        updateProjectAfterCreateMrq,
      }}
    >
      {children}
    </BOMDashboardContext.Provider>
  );
}

export { BOMDashboardContextProvider, BOMDashboardContext };
